module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_datarepup_m2.301761434a5e160f20e9f973715f8874.png";